import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type PeopleTableState = {
	peopleTable: {
		currentNameSearchValue: string;
		pager: { numPages: number; pageId: number };
	};
};

type PeopleTableActions = {
	setCurrentNameSearchValue: (user: PeopleTableState['peopleTable']['currentNameSearchValue']) => void;
	setPeopleTablePagerPageId: (pageId: PeopleTableState['peopleTable']['pager']['pageId']) => void;
	setPeopleTablePagerNumPages: (numPages: PeopleTableState['peopleTable']['pager']['numPages']) => void;
};

export type PeopleTableSlice = PeopleTableState & PeopleTableActions;

const peopleTableInitialState: PeopleTableState = {
	peopleTable: {
		currentNameSearchValue: '',
		pager: { numPages: 0, pageId: 1 },
	},
};

export function peopleTableSlice(set: NamedSet<ZustandStore>): PeopleTableSlice {
	return {
		...peopleTableInitialState,
		setCurrentNameSearchValue(currentNameSearchValue: PeopleTableState['peopleTable']['currentNameSearchValue']): void {
			set(
				(state: PeopleTableState) => {
					state.peopleTable.currentNameSearchValue = currentNameSearchValue;
					return state;
				},
				false,
				'[setCurrentNameSearchValue]',
			);
		},
		setPeopleTablePagerPageId(pageId: PeopleTableState['peopleTable']['pager']['pageId']): void {
			set(
				(state: PeopleTableState) => {
					state.peopleTable.pager.pageId = pageId;
					return state;
				},
				false,
				'[setPeopleTablePagerPageId]',
			);
		},
		setPeopleTablePagerNumPages(numPages: PeopleTableState['peopleTable']['pager']['numPages']): void {
			set(
				(state: PeopleTableState) => {
					state.peopleTable.pager.numPages = numPages;
					return state;
				},
				false,
				'[setPeopleTablePager]',
			);
		},
	};
}
